<template>
  <div class="consult">
    <ul>
		<li v-for="(item,itemkey) in action_info" :key="itemkey">
			<p class="consult-title">
				<strong>{{ item.action_way_msg }}</strong>
				<span>{{ item.createtime }}</span>
			</p>
			<h3>{{ item.msg }}</h3>
			<div
			  v-if="item.refunds_data.length > 0"
			  class="consult-info"
			  v-for="(info,index) in item.refunds_data"
			  :key="index"
			>
			  {{ info }}
			</div>
			<!-- 凭证图片 -->
			<p v-if="item.voucher_data" class="consult-info">
				{{ item.voucher_data.name }}
			</p>
			<p v-if="item.voucher_data" class="voucher">
				<img
				  @click="isImgShow = true"
				  v-for="(img,imgkey) in item.voucher_data.img"
				  :key="imgkey"
				  :src="img"
				  :preview="itemkey"
				>
			</p>
		</li>
	</ul>
	<div
	  v-if="refunds_info.button_message == 1"
	  @click="$router.push('/order/consult_message/' + refunds_info.refunds_id)"
	  class="consult-footer-button"
	>
	  发表留言
	</div>
  </div>
</template>

<script>
import { refundConsult } from "@api/order";
export default {
  name: "RefundConsult",
  components: {
  },
  data() {
    return {
		action_info:{},
		refunds_info:{},
		isImgShow:false
    };
  },
  watch: {
    $route(n) {
      if(n.name == 'RefundConsult'){this.getRefundConsult();}
    }
  },
  mounted() {
	this.getRefundConsult();
  },
  methods: {
	getRefundConsult(){
		let that = this,
		  sn = this.$route.params.id;
		refundConsult(sn).then(res => {
			that.action_info = res.data.action_info;
			that.refunds_info = res.data.refunds_info;
			//由于这里的imgList是动态获取的，所以在成功请求到数据后在加上this.$previewRefresh()重置
			that.$previewRefresh();
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	}
  },
  
};
</script>
<style scoped>
.consult ul{margin-bottom: 1.2rem;}
.consult ul li{background-color: #fff;margin-top: 0.13rem;padding: 0.2rem 0.3rem;}
.consult ul li:first-child{margin-top: 0;}
.consult ul li .consult-title{border-bottom: 1px solid #eee;padding: 0.2rem 0;display: flex;justify-content: space-between;}
.consult ul li .consult-title span{font-size: 0.26rem;color: #777;}
.consult ul li h3{padding: 0.2rem 0 0.1rem 0;font-size: 0.28rem;}
.consult-footer-button{position: fixed;left: 0;bottom: 0;height: 1rem;line-height: 1rem;text-align: center;background-color: #fff;color: #3876ff;width: 100%;font-size: 0.3rem;border-top: 1px solid #eee;}
.consult-info{font-size: 0.26rem;margin-top: 0.1rem;word-break: break-word;}
.voucher{display: flex;align-items: center;margin-top: 0.1rem;}
.voucher img{width: 2rem;margin-left: 0.1rem;}
.voucher img:first-child{margin-left: 0;}
.img-mask{position: fixed;top: 0;left: 0;background-color: #000;width: 100%;height: 100%;display: flex;align-items: center;z-index: 999;}
.img-mask img{width: 100%;}
@media screen and (min-width:960px){
	.consult{width: 3.75rem;}
	.consult ul{margin-bottom: 0.6rem;}
	.consult ul li{margin-top: 0.06rem;padding: 0.1rem 0.15rem;}
	.consult ul li .consult-title{padding: 0.1rem 0;}
	.consult ul li .consult-title span{font-size: 0.13rem;}
	.consult ul li h3{padding: 0.1rem 0 0.05rem 0;font-size: 0.14rem;}
	.consult-footer-button{height: 0.5rem;line-height: 0.5rem;font-size: 0.15rem;}
	.consult-info{font-size: 0.13rem;margin-top: 0.05rem;}
	.voucher{margin-top: 0.05rem;}
	.voucher img{width: 1rem;margin-left: 0.05rem;}
}
</style>
